// import { CloseCircleFilledIcon, FileFilledIcon } from '@icons'
import { getDropzoneData } from '@components/FileUploader/FileUploader.utils'
import IconButton from '@components/IconButton/IconButton'
import { faFile, faTrash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material'

const styles = {
	previewItem: {
		p: 0,
		m: 0.5,
		width: 80,
		height: 80,
		borderRadius: 1.25,
		position: 'relative',
		display: 'inline-flex',
		verticalAlign: 'text-top',
		border: (theme) => `solid 1px ${theme.palette.divider}`,
	},
	item: {
		my: 1,
		px: 2,
		py: 0.75,
		borderRadius: 0.75,
		border: (theme) => `solid 1px ${theme.palette.divider}`,
	},
	removeButton: {
		top: -10,
		right: -10,
		position: 'absolute',
	},
}
type Props = {
	files?: File[] | string[]
	onRemove?: (file: File) => void
}

/**
 * Show preview of uploaded files.
 */
export default function FilesPreview({ files = [], onRemove = null }: Props) {
	const hasFile = files.length > 0

	return (
		<List disablePadding sx={{ ...(hasFile && { my: 1 }) }}>
			{files.map((file, index) => {
				const { key, name } = getDropzoneData(file, index)
				return (
					<ListItem key={key} sx={styles.item}>
						<ListItemIcon>
							<FontAwesomeIcon icon={faFile} style={{ fontSize: '1rem' }} />
						</ListItemIcon>
						<ListItemText
							primary={typeof file === 'string' ? file : name}
							primaryTypographyProps={{ variant: 'subtitle2' }}
						/>
						{onRemove && (
							<IconButton
								size="small"
								icon={faTrash}
								edge="end"
								color="primary"
								onClick={() => onRemove(file)}
							/>
						)}
					</ListItem>
				)
			})}
		</List>
	)
}
